<template>
  <div class="all-bg">
    <Search :sreachData="searchKey"></Search>
    <CommonTab></CommonTab>
    <IndexCategory>
      <li>全部分类</li>
    </IndexCategory>
    <div class="layout">
      <div class="layout-left">
        <div class="layout-left--top">
          <div class="title">专科用药</div>
          <div class="category">
            <div
              class="category-item"
              v-for="(item, index) of categoryList"
              :key="item.id"
            >
              <div
                class="category-item--title"
                :class="categoryIndex !== index ? 'active' : ''"
                @click="showCategory(index)"
              >
                <span></span>{{ item.cate_name }}
              </div>
              <div
                class="category-item--list"
                :class="categoryIndex === index ? 'on' : ''"
                v-show="categoryIndex === index"
              >
                <span
                  v-for="(val, ind) of item.children"
                  :key="val.id"
                  :class="secondIndex === ind ? 'on' : ''"
                  @click="changeSecondId(val.id, ind)"
                  >{{ val.cate_name }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="layout-left--bottom">
          <HotRecommendation></HotRecommendation>
        </div>
      </div>
      <div class="layout-right">
        <div class="layout-right--top">
          <div class="order">
            <div>排序：</div>
            <div
              :class="activeIndex === 0 ? 'on' : ''"
              @click="changeActiveIndex(0)"
            >
              默认
            </div>
            <div
              :class="[
                activeIndex === 1 ? 'on' : '',
                priceDefault ? 'active' : ''
              ]"
              @click="changeActiveIndex(1)"
            >
              价格<Icon type="arrow-down-a" class="icon"></Icon>
            </div>
            <div
              :class="[
                activeIndex === 2 ? 'on' : '',
                saleDefault ? 'active' : ''
              ]"
              @click="changeActiveIndex(2)"
            >
              销量<Icon type="arrow-down-a" class="icon"></Icon>
            </div>
            <div
              :class="[
                activeIndex === 3 ? 'on' : '',
                newDefault ? 'active' : ''
              ]"
              @click="changeActiveIndex(3)"
            >
              新品<Icon type="arrow-down-a" class="icon"></Icon>
            </div>
          </div>
          <div class="page">
            <div class="page-total">总计 {{ totalNum }} 个记录</div>
            <div class="page-num">
              <span>{{ currentPage }}</span
              >/{{ totalPage }}
            </div>
            <div class="page-up" v-if="currentPage > 1" @click="changeUpPage">
              <Icon type="arrow-left-b" class="up"></Icon>上一页
            </div>
            <div class="page-next" @click="changeNextPage">
              下一页<Icon type="arrow-right-b" class="next"></Icon>
            </div>
            <div class="page-input">
              到第
              <input type="text" v-model="inputPage" />
              页
            </div>
            <div class="page-conform" @click="jumpPage">确定</div>
          </div>
        </div>
        <div class="layout-right--content">
          <Spin fix v-if="loading">
            <Icon type="load-c" size="40" class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
          <div
            class="item"
            v-for="item of productList"
            :key="item.id"
            @click="goDetail(item.id)"
          >
            <div class="img">
              <img :src="item.image" alt="" />
            </div>
            <div class="title">
              {{ item.store_name }}
            </div>
            <div class="price">
              <div class="price-left">￥{{ item.price }}</div>
              <div class="sales">已售{{ item.sales }}件</div>
            </div>
            <div class="btn-box">
              查看详情
            </div>
          </div>
        </div>
        <div class="layout-right--bottom" v-if="totalNum > 20">
          <div class="page">
            <div class="page-total">总计 {{ totalNum }} 个记录</div>
            <div class="page-num">
              <span>{{ currentPage }}</span
              >/{{ totalPage }}
            </div>
            <div class="page-up" v-if="currentPage > 1" @click="changeUpPage">
              <Icon type="arrow-left-b" class="up"></Icon>上一页
            </div>
            <div class="page-next" @click="changeNextPage">
              下一页<Icon type="arrow-right-b" class="next"></Icon>
            </div>
            <div class="page-input">
              到第
              <input type="text" v-model="inputPage" />
              页
            </div>
            <div class="page-conform" @click="jumpPage">确定</div>
          </div>
        </div>
      </div>
    </div>
    <AuthModel :modelAuth="modelAuth"></AuthModel>
    <ThreeModel ref="modalThreeChild"></ThreeModel>
  </div>
</template>

<script>
import Search from "@/components/pc/Search";
import CommonTab from "@/components/pc/nav/CommonTab";
import IndexCategory from "@/components/pc/nav/IndexCategory";
import HotRecommendation from "@/components/pc/goodsDetail/HotRecommendation";
import AuthModel from "@/components/pc/authenticate/AuthModel";
import ThreeModel from "@/components/pc/authenticate/ThreeModel";
import { getProducts, getCategory } from "@api/public";
import { getUserInfo } from "@api/user";
export default {
  name: "GoodsList",
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  data() {
    return {
      userInfo: {},
      searchKey: "", // 搜索词
      productList: [],
      limit: 20,
      sid: 0, // 二级目录，搜索需要的参数
      news: 0,
      priceOrder: "",
      salesOrder: "",
      totalNum: 0,
      currentPage: 1,
      totalPage: 0,
      activeIndex: 0,
      categoryList: [],
      categoryIndex: "",
      secondIndex: "",
      modelAuth: false, // 资质认证弹窗
      priceDefault: false,
      saleDefault: false,
      newDefault: false,
      inputPage: "",
      loading: false
    };
  },
  watch: {
    $route(to) {
      if (Object.keys(to.query).length > 0 && to.query.sreachData.length > 0) {
        this.searchKey = to.query.sreachData;
        this.sid = 0;
        this.getProductsInfo();
      }
    }
  },
  created() {
    getUserInfo().then(res => {
      this.userInfo = res.data;
    });
    const mainId = this.$route.params.mainId; // 一级菜单Id
    const secondId = this.$route.params.secondId; // 二级菜单Id
    this.searchKey = this.$route.query.sreachData;
    this.sid = secondId;
    getCategory().then(res => {
      this.categoryList = res.data;
      if (mainId && secondId) {
        // 接收首页传过来的菜单id
        this.categoryList.forEach((item, index) => {
          if (item.id === mainId) {
            this.categoryIndex = index;
            item.children.forEach((item1, index1) => {
              if (item1.id === secondId) {
                this.secondIndex = index1;
              }
            });
          }
        });
      }
    });
  },
  mounted() {
    this.searchKey = this.$route.query.sreachData;
    this.getProductsInfo();
  },
  methods: {
    getProductsInfo() {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        keyword: this.searchKey,
        sid: this.sid,
        news: this.news,
        priceOrder: this.priceOrder,
        salesOrder: this.salesOrder
      };
      this.loading = true;
      getProducts(params)
        .then(res => {
          this.productList = res.data;
          this.totalNum = parseInt(res.msg);
          this.totalPage = Math.ceil(this.totalNum / this.limit);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goDetail(id) {
      this.$router.push("/goodsDetail/" + id);
      // if (this.userInfo.is_certification === 0) {
      //   this.modelAuth = true;
      // } else if (this.userInfo.is_certification === 1) {
      //   this.$router.push("/goodsDetail/" + id);
      // } else if (this.userInfo.is_certification === 2) {
      //   this.$Modal.info({ content: "您的资质认证正在审核中" });
      // } else {
      //   this.$refs.modalThreeChild.newValue = true;
      // }
    },
    showCategory(index) {
      if (index === this.categoryIndex) {
        this.categoryIndex = "";
        return;
      }
      this.categoryIndex = index;
      this.secondIndex = "";
    },
    changeSecondId(id, index) {
      this.sid = id;
      this.secondIndex = index;
      // this.categoryIndex = 1;
      this.totalNum = 0;
      this.searchKey = "";
      this.getProductsInfo();
    },
    changeUpPage() {
      this.currentPage--;
      this.getProductsInfo();
    },
    changeNextPage() {
      if (this.currentPage === this.totalPage) {
        return;
      }
      this.currentPage++;
      this.getProductsInfo();
    },
    jumpPage() {
      this.currentPage = this.inputPage;
      this.getProductsInfo();
    },
    changeActiveIndex(index) {
      if (this.activeIndex === 1 && index === 1) {
        this.priceDefault = !this.priceDefault;
        if (!this.priceDefault) {
          this.priceOrder = "asc";
        } else {
          this.priceOrder = "desc";
        }
        this.getProductsInfo();
        return;
      }
      if (this.activeIndex === 2 && index === 2) {
        this.saleDefault = !this.saleDefault;
        if (!this.saleDefault) {
          this.salesOrder = "asc";
        } else {
          this.salesOrder = "desc";
        }
        this.getProductsInfo();
        return;
      }
      if (this.activeIndex === 3 && index === 3) {
        this.newDefault = !this.newDefault;
        if (!this.newDefault) {
          this.news = "1";
        } else {
          this.news = "0";
        }
        this.getProductsInfo();
        return;
      }
      this.activeIndex = index;
      if (index === 0) {
        this.priceOrder = "";
        this.salesOrder = "";
        this.news = 0;
      } else if (index === 1) {
        this.priceOrder = "asc";
        this.salesOrder = "";
        this.news = 0;
      } else if (index === 2) {
        this.salesOrder = "asc";
        this.priceOrder = "";
        this.news = 0;
      } else {
        this.news = 1;
        this.priceOrder = "";
        this.salesOrder = "";
      }
      this.getProductsInfo();
    },
    changeShowAuth() {
      this.modelAuth = false;
    }
  },
  components: {
    Search,
    CommonTab,
    IndexCategory,
    AuthModel,
    ThreeModel,
    HotRecommendation
  }
};
</script>
<style lang="stylus" scoped>
.all-bg
  background #fff
  .layout
    width 1200px
    margin 12px auto 0
    padding-bottom 10px
    display flex
    &-left
      width 250px
      margin-right 15px
      &--top
        border 1px solid #e4e4e4
        border-top 2px solid #a9a9a9
        .title
          height 40px
          line-height 40px
          padding-left 56px
          background #f4f7f7
          font-size 16px
          position relative
          border-bottom 1px solid #e4e4e4
          &:before
            content: ''
            display inline-block
            width 16px
            height 16px
            background #79bff6
            position absolute
            left 30px
            top 12px
        .category
          &-item
            border-bottom 1px solid #e4e4e4
            &--title
              height 40px
              line-height 40px
              background #f4f7f7
              font-size 15px
              color #006bf4
              cursor pointer
              span
                display inline-block
                width 16px
                height 16px
                background #dedede
                transform translateY(3px)
                margin-left 40px
                margin-right 10px
                position relative
                &:before
                  content ''
                  display inline-block
                  width 10px
                  height 2px
                  background #fff
                  position absolute
                  top 50%
                  left 50%
                  transform translateX(-50%) translateY(-50%)
              &.active
                color #333
                span
                  &:after
                    content ''
                    display inline-block
                    width 10px
                    height 2px
                    background #fff
                    position absolute
                    top 50%
                    left 50%
                    transform translateX(-50%) translateY(-50%) rotate(90deg)
            &--list
              margin 10px 10px 10px 65px
              display flex
              justify-content space-between
              flex-wrap wrap
              overflow hidden
              span
                width 47%
                line-height 28px
                font-size 13px
                color #666
                font-family '宋体'
                overflow hidden
                text-overflow ellipsis
                white-space nowrap
                cursor pointer
                &.on
                  color #006bf4
                  font-size 14px
              &.on
                height 100%
      &--bottom
        margin-top 20px

    &-right
      flex 1
      &--top
        background #f4f7f7
        height 40px
        line-height 40px
        display flex
        justify-content space-between
        font-family '宋体'
        font-size 13px
        .order
          margin-left 20px
          display flex
          div
            margin-right 12px
            color #666
            .icon
              margin-left 2px
              transform translateY(1px)
              color #999
            &.on
              color #f3454f
              .icon
                transform rotate(180deg)
                color #f3454f
            &.active
              .icon
                transform rotate(360deg)
            &:not(:first-child)
              cursor pointer
        .page
          display flex
          align-items center
          color #666
          &-num
            margin 0 20px
            span
             color #f3454f
          &-up
            cursor pointer
            height 20px
            line-height 20px
            background #fff
            padding 0 4px
            margin-right 5px
            .up
              margin-right 4px
          &-next
            cursor pointer
            margin-right 25px
            height 20px
            line-height 20px
            background #fff
            padding 0 4px
            .next
              margin-left 4px
          &-input
            input
              width 40px
              height 24px
              background #fff
              border 1px solid #e3e3e3
              text-align center
              padding 2px 0
          &-conform
            cursor pointer
            width 40px
            height 20px
            line-height 20px
            text-align center
            background #1881f2
            margin-left 5px
            margin-right 20px
            color #fff
      &--content
        margin-top 10px
        display flex
        flex-wrap wrap
        position relative
        min-height 200px
        .item
          cursor pointer
          width 24%
          border 2px solid #f1f1f1
          margin-right 1.3%
          margin-top 30px
          padding 10px
          &:hover
            border 2px solid #efa7a7
          &:nth-child(4n)
            margin-right 0
          &:nth-child(-n+4)
            margin-top 0
          .img
            width 180px
            height 180px
            margin 10px auto 0
            img
              width 100%
              height 100%
          .title
            margin-top 10px
            color #666
            font-family '宋体'
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
          .price
            display flex
            color #ff5c4d
            justify-content space-between
            line-height 24px
            .price-left
              font-size 16px
              transform translateX(-3px)
            .sales
              font-size 12px
          .btn-box
            height 26px
            width 100px
            margin 10px auto
            text-align center
            line-height 26px
            color #646464
            border 1px solid #dcdcdc
            background rgb(244,244,244)
            border-radius 4px
      &--bottom
        margin-top 10px
        background #f4f7f7
        height 40px
        line-height 40px
        display flex
        flex-direction row-reverse
        justify-content space-between
        font-family '宋体'
        font-size 13px
        .page
          display flex
          align-items center
          color #666
          &-num
            margin 0 20px
            span
             color #f3454f
          &-up
            cursor pointer
            height 20px
            line-height 20px
            background #fff
            padding 0 4px
            margin-right 5px
            .up
              margin-right 4px
          &-next
            cursor pointer
            margin-right 25px
            height 20px
            line-height 20px
            background #fff
            padding 0 4px
            .next
              margin-left 4px
          &-input
            input
              width 40px
              height 24px
              background #fff
              border 1px solid #e3e3e3
              text-align center
              padding 2px 0
          &-conform
            cursor pointer
            width 40px
            height 20px
            line-height 20px
            text-align center
            background #1881f2
            margin-left 5px
            margin-right 20px
            color #fff
.demo-spin-icon-load
  animation ani-demo-spin 1s linear infinite
@keyframes ani-demo-spin
  from
    transform rotate(0deg)
  50%
    transform rotate(180deg)
  to
    transform rotate(360deg)
</style>
